import React from "react";
import DrinkCup from "../../../assets/images/drinkCup.svg";

const Cup = ({ active }: { active: boolean }) => (
    <span
        className="inline-block h-4 w-3"
        style={{
            WebkitMask: `url(${DrinkCup}) no-repeat center / contain`,
            mask: `url(${DrinkCup}) no-repeat center / contain`,
            backgroundColor: active ? "#f97316" : "#6b7280", // orange-500 / gray-600
        }}
        aria-hidden
    />
);

export default Cup;
